import React from 'react';
import styled from 'styled-components';
import useOnclickOutside from 'react-cool-onclickoutside';
import { useIsMobileOrTablet } from '../../../../../shared/theme';
import {
  DropdownText,
  OptionsContainer,
} from '../../../common/dropdown/styles';
import { Button, Clear, SDropdownIcon } from '../common';
import {
  FilterName,
  InnerContainer,
  SDropdownContainer,
  SecondaryLabel,
} from './common';
import Option from './option';
import Hint from './hint';
import filterPropTypes from './prop-types';
import useFundsStateStore from '../../../common/funds-state-hook';

const Container = styled.div`
  z-index: 3;
`;

const SOptionsContainer = styled(OptionsContainer)`
  width: 375px;
  padding: 32px 20px 16px;
`;

const ActionContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 40px;
`;

const SButton = styled(Button)`
  margin-left: auto;
`;

export default function Desktop({
  assetClasses,
  clearFilter,
  dropdownLabel,
  dropdownClassName,
  filterCount,
  onClick,
  showOptions,
  applyFilter,
}) {
  const showAssetClassFilterHint = useFundsStateStore(state => state.showAssetClassFilterHint);

  const optionsRef = React.useRef();
  const dropdownRef = React.useRef();
  useOnclickOutside(() => {
    showOptions && applyFilter();
  }, { refs: [dropdownRef, optionsRef] });

  const isMobileOrTablet = useIsMobileOrTablet();

  return (
    <Container>
      <SDropdownContainer ref={dropdownRef} onClick={onClick} className={dropdownClassName}>
        <DropdownText>{dropdownLabel}</DropdownText>
        <SDropdownIcon className={`icon-lw icon-lw-chevron-${showOptions ? 'up' : 'down'}`} />
      </SDropdownContainer>
      {showOptions && (
        <SOptionsContainer ref={optionsRef} className="ignore-onclickoutside">
          <FilterName>Filter by Asset Class</FilterName>
          <SecondaryLabel>Select Asset Class</SecondaryLabel>
          <InnerContainer>
            {assetClasses.map(ac => <Option key={ac.id} assetClass={ac} />)}
          </InnerContainer>
          <ActionContainer>
            <Clear className={filterCount > 0 ? 'active' : ''} onClick={clearFilter}>
              {filterCount > 1 ? 'Clear All' : 'Clear'}
            </Clear>
            <SButton onClick={applyFilter}>Apply</SButton>
          </ActionContainer>
        </SOptionsContainer>
      )}
      {showAssetClassFilterHint && <Hint ref={isMobileOrTablet ? dropdownRef : optionsRef} />}
    </Container>
  );
}

Desktop.propTypes = filterPropTypes;
